export const ROUTES_PATH = {
  DASHBOARD: '/dashboard',
  TELEPHONIC_CREATE: '/inquiry/telephonic/create',
  NEW_INQUIRY: '/inquiry/new-inquiry',
  EDIT_INQUIRY: '/inquiry/edit-inquiry/:id',
  NEW_INQUIRY_MOVE_TO_WALKIN_INQUIRY: '/inquiry/new-inquiry/T2W/:id',
  TELEPHONIC_LIST: '/inquiry/telephonic',
  TELEPHONIC_EDIT: '/inquiry/telephonic/edit',
  TELEPHONIC_FOLLOWUP_LIST: '/inquiry/telephonic/followup',

  WALK_IN_LIST: '/inquiry/walkin',
  WALK_IN_CREATE: '/inquiry/walkin/create',
  WALK_IN_EDIT: '/inquiry/walkin/edit',
  WALK_IN_FOLLOWUP_LIST: '/inquiry/walkin/followup',

  FOLLOW_UP_LIST: '/inquiry/followup',
  FOLLOW_UP_LIST_EDIT: '/inquiry/followup/edit',
  FOLLOW_UP_LIST_CREATE: '/inquiry/followup/create/:id',

  LOGIN: '/login',
  VERIFY_OTP: '/verify-otp',
  RESET_PASSWORD: '/reset-password',
  FORGOT_PASSWORD: '/forgot-password',
  BRANCH: '/branch',
  LOGIN_WITH_PASSWORD: '/login-email',
  INQUIRY: '/inquiry',

  COURSE: '/course',
  FACULTY: '/faculty',
  ENROLLMENT: '/enrollment',
  ADD_ENROLLMENT: '/enrollment/add-enrollment',
  EDIT_ENROLLMENT: '/enrollment/edit-enrollment/:id',
  TIMETABLE: '/timetable',
  ATTENDANCE: '/attendance',
  STUDENT: '/student',
  EXAM_ASSESSMENT: '/exam-assessment',
  EXAM_RESULT_PARENT: '/exam-assessment/result',
  EXAM_START_ASSESSMENT: '/assessment',
  INVENTORY: '/inventory',
  REPORTS: '/reports',
  VIEW_COURSE: '/view-course',
  BRANCH_ADD: '/branch/add-branch',
  BRANCH_EDIT: '/branch/:id',

  STUDENT_DASHBOARD: '/dashboard',
  STUDENT_PRACTICE: '/student-practice',
  STUDENT_EXAM_TEST: '/student-exam-test',
  STUDENT_TIMETABLE: '/student-timetable',
  STUDENT_COURSE_DETAILS: '/dashboard/course-details/:id',
  STUDENT_FEES: '/student-fees',
  STUDENT_PROFILE: '/student-profile',
  STUDENT_EXAM: '/student-exam',
  MY_COURSE: '/my-course',
  FACULTY_DASHBOARD: '/dashboard',
  BILLING_HISTORY: '/billing-history',
  FACULTY_EXAM_ASSESSMENT: '/exam-assessment/faculty',
  FACULTY_ADD: '/faculty/add-faculty',
  FACULTY_EDIT: '/faculty/edit-faculty/:id',
  PLACEMENTS: '/placements',
  ADD_COURSE_INFORMATION: '/course/add-course/information',
  ADD_COURSE_CONTENT: '/course/add-course/content',
  ADD_COURSE_PRICING: '/course/add-course/pricing',
  BILLING_INFO: '/faculty/billing-info',
  BILLING_INFO_ID: '/faculty/billing-info/:id',
  FACULTY_PROFILE: '/faculty-profile',
  EDIT_COURSE_INFORMATION: '/course/edit-course/information/:id',
  EDIT_COURSE_CONTENT: '/course/edit-course/content/:id',
  EDIT_COURSE_PRICING: '/course/add-course/pricing/:id',
  FACULTY_EXAM_RESULT_PARENT: '/exam-assessment/faculty/result/:timeTableId',
  ROLE_MANAGEMENT: '/role-management',
  ADD_ROLE: '/role-management/add-role',
  EDIT_ROLE: '/role-management/:id',
  USER_MANAGEMENT: '/user-management',
  USER_MANAGEMENT_ADD: '/user-management/add-user',
  USER_MANAGEMENT_EDIT: '/user-management/edit-user/:id',
  FEES_COLLECTION_REPORT:'/reports/feesCollection-report',
  FEES_COLLECTION_DUE_REPORT:'/reports/feesCollectionDue-report',
  STUDENT_DETAILS_REPORT:'/reports/studentDetails-report',
  ATTENDANCE_REPORT:'/reports/attendance-report',
  EXAM_RESULT_REPORT:'/reports/examResult-report',
  FACULTY_LECTURE_REPORT:'/reports/facultyLecture-report',
  LECTURE_COUNT_REPORT:'/reports/lectureCount-report',
  CONFIGURATION: '/configuration',
  REPORT_TIMETABLE: '/report-timetable',
  TIMETABLE_REPORT: '/reports/time-table',
  KIT_DISTRIBUTION_REPORT: '/reports/kit-distribution',
  KIT_SUMMARY_REPORT: '/reports/kit-summary',
  SOURCE_WISE_INQUIRY_REPORT: '/reports/source-wise-inquiry',
  DAILY_REPORT: '/reports/daily-report',
  INQUIRY_SOURCE: '/master/inquirySource',
  AREA: '/master/area-list',
  EDUCATION_QUALIFICATION:"/master/education-qualification",
  AREA_WISE_INQUIRY_REPORT: '/reports/areawise-inquiry-report',
  INQUIRY_REPORT: '/reports/inquiry-report',
  BANKS: '/master/banks',
  DESIGNATION: '/master/designation',
  TOTAL_DUE_FEES: '/reports/fees-outstanding-report'
}

export const permissions = {
  ADMIN_DASHBOARD: 'ADMIN_DASHBOARD',
  STUDENT_DASHBOARD: 'STUDENT_DASHBOARD',
  FACULTY_DASHBOARD: 'FACULTY_DASHBOARD',
  VIEW_COURSE: 'LIST_COURSE',
  ADD_COURSE: 'ADD_COURSE',
  ASSIGN_TO_BRANCH: 'ASSIGN_TO_BRANCH',
  EDIT_COURSE: 'EDIT_COURSE',
  ARCHIVE_COURSE: 'ARCHIVE_COURSE',
  VIEW_INQUIRY: 'LIST_INQUIRY',
  ADD_INQUIRY: 'ADD_INQUIRY',
  MOVE_TO_WALKIN: 'MOVE_TO_WALKIN',
  TAKE_FOLLOW_UP: 'TAKE_FOLLOW_UP',
  EDIT_INQUIRY: 'EDIT_INQUIRY',
  ARCHIVE_INQUIRY: 'ARCHIVE_INQUIRY',
  ENROLL_INQUIRY: 'ENROLL_INQUIRY',
  VIEW_BRANCH: 'LIST_BRANCH',
  ADD_BRANCH: 'ADD_BRANCH',
  MANAGE_CLASSROOM: 'MANAGE_CLASSROOM',
  MANAGE_BATCH: 'MANAGE_BATCH',
  EDIT_BRANCH: 'EDIT_BRANCH',
  ARCHIVE_BRANCH: 'ARCHIVE_BRANCH',
  VIEW_FACULTY: 'LIST_FACULTY',
  ADD_FACULTY: 'ADD_FACULTY',
  BILLING_INFO: 'BILLING_INFO',
  BILLING_HISTORY: 'BILLING_HISTORY',
  EDIT_FACULTY: 'EDIT_FACULTY',
  ARCHIVE_FACULTY: 'ARCHIVE_FACULTY',
  VIEW_ENROLLMENT: 'LIST_ENROLLMENT',
  TRANSFER_BATCH_OR_BRANCH: 'TRANSFER_BATCH_OR_BRANCH',
  EDIT_ENROLLMENT: 'EDIT_ENROLLMENT',
  ARCHIVE_ENROLLMENT: 'ARCHIVE_ENROLLMENT',
  VIEW_TIMETABLE: 'LIST_TIMETABLE',
  FILTER_TIMETABLE: 'FILTER_TIMETABLE',
  ADD_TIMETABLE: 'ADD_TIMETABLE',
  EDIT_TIMETABLE: 'EDIT_TIMETABLE',
  VIEW_INVENTORY: 'LIST_INVENTORY',
  ADD_INVENTORY: 'ADD_INVENTORY',
  ADD_INVENTORY_TO_BRANCH: 'ADD_INVENTORY_TO_BRANCH',
  EDIT_INVENTORY: 'EDIT_INVENTORY',
  INVENTORY_HISTORY: 'INVENTORY_HISTORY',
  VIEW_REPORTS: 'VIEW_REPORTS',
  VIEW_PLACEMENTS: 'VIEW_PLACEMENTS',
  VIEW_ROLE: 'LIST_ROLE',
  ADD_ROLE: 'ADD_ROLE',
  EDIT_ROLE: 'EDIT_ROLE',
  VIEW_USERS: 'LIST_USER',
  ADD_USER: 'ADD_USER',
  EDIT_USER: 'EDIT_USER',
  VIEW_STUDENT_PROFILE: 'VIEW_STUDENT_PROFILE',
  VIEW_COURSE_DETAIL: 'VIEW_COURSE_DETAIL',
  VIEW_STUDENT_FEES: 'VIEW_STUDENT_FEES',
  VIEW_STUDENT_EXAM: 'VIEW_STUDENT_EXAM',
  VIEW_EXAM_ASSESSMENT_RESULT: 'VIEW_EXAM_ASSESSMENT_RESULT',
  VIEW_FACULTY_EXAM_ASSESSMENT: 'VIEW_FACULTY_EXAM_ASSESSMENT',
  VIEW_FACULTY_PROFILE: 'VIEW_FACULTY_PROFILE',
  VIEW_ASSESSMENT: 'VIEW_ASSESSMENT',
  VIEW_CONFIGURATION: 'VIEW_CONFIGURATION',
  VIEW_DUE_COLLECTION: 'EDIT_ENROLLMENT',
}

export const UI_CONSTANT = {
  RAZORPAY_TITLE: 'Acquaint Academy',
  PAID: 'Paid',
  PAY_NOW: 'Pay now',
  UNPAID: 'Unpaid',
  SUBMIT: 'Submit',
  ADD: 'Add',
  EDIT: 'Edit',
  FILTER: 'Filter',
  BACK: 'Back',
  OR: 'OR',
  ARCHIVE: 'Archive',
  DASHBOARD: 'Dashboard',
  REPORT: 'Reports',
  SAVE: 'Save',
  SAVE_NOW: 'Save Now',
  CLEAR_ALL: 'Clear all',
  LOADING: 'Loading...',
  SEND: 'Send',
  SEND_MAIL: 'Send Mail',
  NEXT: 'Next',
  PUBLISH: 'Publish',
  MY_PROFILE: 'My Profile',
  EDIT_PROFILE: 'Edit Profile',
  ATTACH_FILES: 'Attach Files',
  ATTACH_MORE: 'Attach More',
  POP_UP_ACTION: 'ACTION',
  TABLE_HEADER_SAW: 'Saw',
  TABLE_HEADER_ENTRIES: 'entries',
  ARCHIVE_MESSAGE: 'Are you sure you want to archive ? ',
  SAVE_AS_DRAFT: 'Save as Draft',

  LECTURE: 'Lecture',
  ONLINE_EXAM: 'Online Exam',
  OFFLINE_EXAM: 'Offline Exam',
  MANAGE_BATCH: 'Manage Batch',
  //USER ROLE
  ADMIN_ROLE: 'admin',
  BRANCH_ROLE: 'branch',
  INQUIRY_ROLE: 'inquiry',
  FACULTY_ROLE: 'faculty',
  STUDENT_ROLE: 'student',

  BILLING_HISTORY: {
    LABEL_BILLING_HISTORY: 'Billing History',
    BILLING_INFORMATION: 'Billing Information',
  },

  BATCH: {
    BATCH_INFORMATION: 'Batch Information',
    FORM_DESCRIPTION: 'Please make sure fill all the filed before click on submit button',
    ALL_BATCH: 'All Batch'
  },

  BRANCH: {
    LABEL_BRANCH: 'Branch',
    LABEL_COURSE: 'Course',
    ADD_BRANCH: 'Add Branch',
    EDIT_BRANCH: 'Edit Branch',
    NEW_BRANCH: 'New Branch',
    MANAGE_CLASSROOM: 'Manage Classroom',
    MANAGE_BATCH: 'Manage Batch',
    BRANCH_TABLE_HEADER: 'All Branch',
    BRANCH_INFORMATION: 'Branch Information',
    FORM_DESCRIPTION: 'Please make sure fill all the filed before click on next button',
    USER_DETAILS: 'User Details',
  },

  COURSE: {
    LABLE_COURSE: 'Course',
    COURSE_TABLE_HEADER: 'All Course',
    ADD_COURSE: 'Add Course',
    ADD_MODULE: 'Add Module',
    EDIT_COURSE: 'Edit Course',
    COURSE_PRICING: 'Course Pricing',
    EDIT_COURSE_PRICING: 'Edit Course Pricing',
    NEW_COURSE: 'New Course',
    COURSE_CONTENT: 'Course Content',
    EDIT_COURSE_CONTENT: 'Edit Course Content',
    COURSE_INFORMATION: 'Course Information',
    EDIT_COURSE_INFORMATION: 'Course Information',
    FORM_DESCRIPTION: 'Please make sure fill all the filed before click on next button',
    ADD_NEW_TOPIC: 'Add New Topic',
    CHARACTER_COUNT: '150 Character',
    ENROLL_MATERIALS: 'Enroll Materials',
    ENROLL_MATERIALS_DESCRIPTION: "'Click on items you want to add to this course...",
  },

  ENROLLMENT: {
    LABEL_ENROLLMENT: 'Enrollment',
    ADD_ENROLLMENT: 'Add Enrollment',
    ALL_ENROLLMENT: 'All Enrollment',
    NEW_ENROLLMET: 'New Enrollment',
    EDIT_ENROLLMENT: 'Edit Enrollment',
    COURSE_DETAILS: 'Course Details',
    PERSONAL_INFORMATION: 'Personal information',
    ACADEMIC_DETAILS: 'Academic Details',
    WORK_EXPERIENCE: 'Work Experience',
    FEES_STRUCTURE: 'Fees Structure',
    FEES_COLLECTION: 'Fees Collection',
    FORM_DESCRIPTION: 'Please make sure fill all the filed before click on next button',
  },

  EXAM_ASSESSMENT: {
    LABEL_EXAM_ASSESSMENT: 'Exam Assessment',
    ALL_EXAM: 'All Exam',
    START_EXAM: 'Start Exam',
  },

  ATTENDANCE: {
    PRESENT: 'Present',
    ABSENT: 'Absent'
  },

  FACULTY: {
    LABEL_FACULTY: 'Faculty',
    ADD_FACULTY: 'Add Faculty',
    ALL_FACULTY: 'All Faculty',
    NEW_FACULTY: 'New Faculty',
    EDIT_FACULTY: 'Edit Faculty',
    FORM_DESCRIPTION: 'Please make sure fill all the filed before click on next button',
    FACULTY_INFORMATION: 'Faculty Information',
    FACULTY_BILLING_INFORMATION: 'Billing Information',
    FACULTY_BANK_INFORMATION: 'Bank Information',
  },

  INQUIRY: {
    LABEL_INQUIRY: 'Inquiry',
    INQUIRY_FOLLOWUP: 'Inquiry FollowUp',
    ADD_INQUIRY: 'Add Inquiry',
    NEW_INQUIRY: 'New Inquiry',
    EDIT_INQUIRY: 'Edit Inquiry',
    ALL_INQUIRY: 'All Inquiry',
    PERSONAL_INFORMATION: 'Personal information',
    FORM_DESCRIPTION: 'Please make sure fill all the filed before click on next button',
    INQUIRY_DETAILS: 'Inquiry Details',
    EDUCATION_BACKGROUND: 'Educational Background',
    WORK_EXPERIENCE: 'Work Experience',
    FOLLOWUP_PLANNING: 'Follow-Up and Planning',
    FOLLOWUP_HISTORY_MESSAGE: 'No follow-up history available for this student.',
  },

  INQUIRY_SOURCE: {
    LABEL_INQUIRY_SOURCE: 'Inquiry source',
    ALL_INQUIRY_SOURCE: 'All Inquiry Source',
    ADD_INQUIRY_SOURCE: 'Add Inquiry Source',
  },

  INVENTORY: {
    LABEL_INVENTORY: 'Inventory',
    ADD_INVENTORY: 'Add Inventory',
    NEW_INVENTORY: 'New Inventory',
    EDIT_INVENTORY: 'Edit Inventory',
    ALL_INVENTORY: 'All Inventory',
  },

  LOGIN: {
    WELCOME_TITLE: 'Welcome Back',
    WELCOME_MESSAGE: 'Log in to your account below',
    WELCOME_TITLE_RESET: 'Reset Password',
    WELCOME_MESSAGE_RESET: 'Enter your new password and confirm it below.',
    LOGIN_EMAIL_MSG: 'Email successfully sent in your Email address login in to your account below',
    BACK_TO_LOGIN: 'Back to Login',
    FORGOT_PASSWORD: 'Forgot password ?',
    LOGIN: 'Login',
    LOGIN_WITH_OTP: 'Login with OTP',
    INVALID_OR_EXPIRED: 'Invalid or expired token. Please request a new password reset ',
    LINK: ' Link. ',
    RESET_PASSWORD: 'Reset Password',
    RESEND_OTP: 'Resend OTP',
  },

  ROLE_MANAGEMENT: {
    LABEL_ROLL_MANAGEMENT: 'Role management',
    ADD_ROLE: 'Add Role',
    EDIT_ROLE: 'Edit Role',
    NEW_ROLE: 'New Role',
    ALL_ROLE: 'All Role',
    ALL_PERMISSIONS: 'All permissions',
    ROLE_INFORMATION: 'Role Information',
    FORM_DESCRIPTION: 'Please make sure fill all the filed before click on next button',
  },

  STUDENT_DASHBOURD: {
    COURSE_DETAILS: 'Course Details',
  },

  STUDENT_FEES: {
    FEES: 'Fees',
    DUE_TOTAL_AMOUNT:'Total Due Amount Fees'
  },

  TIME_TABLE: {
    LABEL_TIMETABLE: 'Time Table',
    ADD_TIME_TABLE: 'Add Time Table ',
    ALL_TIME_TABLE: 'All Time Table',
    NEW_TIME_TABLE: 'New Time Table',
    EDIT_TIME_TABLE: 'Edit Time Table',
  },

  USER_MANAGEMENT: {
    LABEL_USER_MANAGEMENT: 'User Management',
    ADD_USER: 'Add User',
    EDIT_USER: 'Edit User',
    ALL_USER: 'All User',
    NEW_USER: 'New User',
    USER_DETAILS: 'User Details',
    FORM_DESCRIPTION: 'Please make sure fill all the filed before click on next button',
  },
  ADMIN_DASHBOARD: {
    COLLECTION_OVERVIEW: 'Collection Overview',
    INQUIRY_OVERVIEW: 'Inquiry Overview',
    INQUIRY_LIST: 'Inquiry List',
    MONTH_WISE_ENROLLMENT_COUNT: 'Month wise enrollment count',
    TELEPHONIC_INQUIRIES: 'Telephonic Inquiries',
    WALK_IN_INQUIRIES: 'Walk-in Inquiries',
    ENROLLMENT: 'Enrollments',
    MONTH_WISE_TOTAL_COLLECTION: 'Month-wise total collection',
    TODAYS_BIRTHDAY: `Today's birthday`,
    DEAD_INQUIRIES: 'Dead Inquiries'
  },

  CONFIGURATION: {
    CONFIGURATION: 'Configuration',
    LABEL_CONFIGURATION: 'Configuration',
  },
  REPORTS: {
    AREA_WISE_INQUIRY_REPORT: {
      LABEL_AREA_WISE_INQUIRY_REPORT: 'Areawise Inquiry Report',
    },
  },
  MASTER_CONFIG: {
    BANKS: {
      LABEL_BANK: 'Bank',
      ALL_BANKS: 'All Banks',
      ADD_BANK: 'Add Bank',
      EDIT_BANK: 'Edit Bank',
    },
    DESIGNATION: {
      LABEL_DESIGNATION: 'Designation',
      ADD_DESIGNATION: 'Add Designation',
      EDIT_DESIGNATION: 'Edit Designation',
      ALL_DESIGNATION: 'All Designation'
    },
    AREA:{
      LABEL_AREA:"Area",
      ALL_AREAS: 'All Areas',
      SELECT_CITY:"Select city",
      SELECT_STATE:"Select State",
      ADD_AREA: 'Add Area',
      EDIT_AREA:"Edit Area"
    },
    EDUCATION_QUALIFICATION:{
      LABEL_EDUCATION_QUALIFICATION:"Education qualification",
      ALL_EDUCATION_QUALIFICATION: 'All Education qualification',
      // SELECT_CITY:"Select city",
      ADD_EDUCATION_QUALIFICATION: 'Add education qualification',
      EDIT_EDUCATION_QUALIFICATION:"Edit education qualification"
    }
  },
}

export const numbers = [
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
]

export const paymentMode = [
  { label: 'Cheque', value: 'Cheque' },
  { label: 'cash', value: 'CASH' },
  { label: 'NEFT', value: 'NEFT' },
  { label: 'IMPS', value: 'IMPS' },
  { label: 'Payment', value: 'Payment' },
  { label: 'Phonepay', value: 'Phonepay' },
]

export const months = [
  { label: 'January', value: 'JAN' },
  { label: 'February', value: 'FEB' },
  { label: 'March', value: 'MAR' },
  { label: 'April', value: 'APR' },
  { label: 'May', value: 'MAY' },
  { label: 'June', value: 'JUN' },
  { label: 'July', value: 'JUL' },
  { label: 'August', value: 'AUG' },
  { label: 'September', value: 'SEP' },
  { label: 'October', value: 'OCT' },
  { label: 'November', value: 'NOV' },
  { label: 'December', value: 'DEC' },
]

export const statuses = [
  { label: 'active', value: 'active' },
  { label: 'inactive', value: 'inactive' },
]

export const schedule = [
  { time: '06:00 AM' },
  { time: '07:00 AM' },
  { time: '08:00 AM' },
  { time: '09:00 AM' },
  { time: '10:00 AM' },
  { time: '11:00 AM' },
  { time: '12:00 PM' },
  { time: '01:00 PM' },
  { time: '02:00 PM' },
  { time: '03:00 PM' },
  { time: '04:00 PM' },
  { time: '05:00 PM' },
  { time: '06:00 PM' },
  { time: '07:00 PM' },
  { time: '08:00 PM' },
  { time: '09:00 PM' },
  { time: '10:00 PM' },
  { time: '11:00 PM' },
]

export const monthList = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const preferredBatch = [
  { label: 'Morning', value: 'morning' },
  { label: 'Evening', value: 'evening' },
  { label: 'Noon', value: 'noon' },
  { label: 'Early Morning', value: 'earlyMorning'  },
  { label: 'Late Evening', value: 'lateEvening'  },
  { label: 'Sunday', value: 'sunday'  },
  { label: 'Other', value: 'other'  },
]

export const priority = [
  { label: 'Hot', value: 'hot' },
  { label: 'Cold', value: 'cold' },
  { label: 'Warm', value: 'warm' },
]

